export const PROVIDER_DASHBOARD_PLACE_STORAGE_KEY_PREFIX = 'sherlook_provider_dashboard_place_id_';

function storageGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function storageSet(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* Ecosia / stockage bloqué */
  }
}

function storageRemove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export function getProviderPlaceStorageKey(providerId: number): string {
  return `${PROVIDER_DASHBOARD_PLACE_STORAGE_KEY_PREFIX}${providerId}`;
}

export function getStoredProviderPlaceId(providerId: number): number | null {
  const raw = storageGet(getProviderPlaceStorageKey(providerId));
  if (!raw) return null;
  const n = parseInt(raw, 10);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function setStoredProviderPlaceId(providerId: number, placeId: number): void {
  storageSet(getProviderPlaceStorageKey(providerId), String(placeId));
}

export function clearAllStoredProviderPlaces(): void {
  try {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key?.startsWith(PROVIDER_DASHBOARD_PLACE_STORAGE_KEY_PREFIX)) {
        keys.push(key);
      }
    }
    keys.forEach((key) => storageRemove(key));
  } catch {
    /* ignore */
  }
}

export const EVENT_ACCESS_LAST_NAMES = new Set(['Accès temporaire', 'Accès événement']);

export function formatDashboardUserDisplayName(user: Record<string, unknown> | null | undefined): string {
  if (!user) return 'Utilisateur';
  const loginUsername = user.login_username;
  if (typeof loginUsername === 'string' && loginUsername.trim() !== '') {
    return loginUsername.trim();
  }
  const first = String(user.first_name ?? user.firstName ?? '').trim();
  const last = String(user.last_name ?? user.lastName ?? '').trim();
  if (EVENT_ACCESS_LAST_NAMES.has(last)) {
    return first || 'Utilisateur';
  }
  const full = [first, last].filter(Boolean).join(' ');
  return full || 'Utilisateur';
}
